export default "__VITE_ASSET__CPzqg2Vf__"